define('SuiteDynamics.HeelAssistItemSwap.NavigationGuard', [
	'Header.MiniCart.View',
	'LiveOrder.Model',
	'underscore',
	'jQuery'
], function (
	HeaderMiniCartView,
	LiveOrderModel,
	_,
	jQuery
) {
	'use strict';

	var MODULE_BOUND = false;

	function truthy(v) { return v === true || v === 'T' || v === '1'; }

	function hasLegacyHeelAssist(lines) {
		return _.some(lines || [], function (line) {
			var item = line && line.item;
			var flag = item && ((item.extras && item.extras.custitem97) || item.custitem97);
			return truthy(flag);
		});
	}

	function closeMiniCartDropdown(viewInstance) {
		try {
			jQuery(document.body).trigger('click');
			var $toggle = viewInstance.$('[data-type="mini-cart"][data-toggle="dropdown"]');
			if ($toggle && $toggle.dropdown) $toggle.dropdown('hide');
		} catch (_) {}
	}

	function getTouchpoint(envComp, key, fallback) {
		try {
			var value = envComp && envComp.getSiteSetting && envComp.getSiteSetting('touchpoints.' + key);
			return value || fallback;
		} catch (_) {
			return fallback;
		}
	}

	function fetchLines(cartComp) {
		var p = LiveOrderModel.getInstance().fetch();
		var getLines = function () { return cartComp.getLines(); };
		return (p && p.then) ? p.then(getLines, getLines) : getLines();
	}

	function setForceModalFlag() {
		try { sessionStorage.setItem('heelassist:forceModal', '1'); } catch (_) {}
	}

	return {
		mountToApp: function (container) {
			if (MODULE_BOUND) return;
			MODULE_BOUND = true;

			var cartComp = container.getComponent('Cart');
			var envComp  = container.getComponent('Environment');

			var originalTrack = HeaderMiniCartView.prototype.trackEvent || function () {};

			HeaderMiniCartView.prototype.trackEvent = _.wrap(originalTrack, function (origFn) {
				var args = Array.prototype.slice.call(arguments, 1);
				var e = args[0];

				if (e && e.preventDefault) {
					e.preventDefault();
					e.stopImmediatePropagation();
				}

				var self = this;

				fetchLines(cartComp).then(function (lines) {
					if (hasLegacyHeelAssist(lines)) {
						setForceModalFlag();
						closeMiniCartDropdown(self);

						var viewcartUrl = getTouchpoint(envComp, 'viewcart', '/scs/goToCart.ssp');
						window.location.assign(viewcartUrl);
						return;
					}

					try { origFn.apply(self, args); } catch (_) {}
					closeMiniCartDropdown(self);

					var checkoutUrl = getTouchpoint(envComp, 'checkout', '/scs/checkout.ssp?is=checkout');
					window.location.assign(checkoutUrl);
				});
			});
		}
	};
});
